import StickyNote from "./SVG/sticky-note.svg?react";

const ActivityDescriptionIcon = () => {
  return <StickyNote />;
};

export default ActivityDescriptionIcon;
